export const defaultSelectStyles = {
  control: styles => ({
    ...styles,
    '&:hover': {
      border: '1px solid #4288c7'
    },
    backgroundColor: 'white',
    minHeight: '28px',
    cursor: 'pointer',
    padding: '4px 10px',
    borderRadius: '5px',
    border: '1px solid #4288c7',
    background: 'rgba(66, 136, 199, 0.00)',
    width: '17vw',
    fontFamily: "'proxima-nova'"
  }),
  menu: styles => ({
    ...styles,
    width: '30vw'
  }),
  placeholder: styles => ({
    ...styles,
    color: '#4973b4',
    fontSize: '14px',
    textAlign: 'left',
    fontFamily: "'proxima-nova'"
  }),
  input: styles => ({
    ...styles,
    color: '#4973b4',
    fontSize: '14px',
    textAlign: 'left',
    fontFamily: "'proxima-nova'"
  }),
  groupHeading: styles => ({
    ...styles,
    fontSize: '12px',
    fontWeight: 500,
    textAlign: 'left',
    color: '#444',
    marginBottom: '10px',
    lineHeight: '21px',
    textTransform: 'capitalize',
    fontFamily: "'proxima-nova'"
  }),
  option: (styles, state) => ({
    ...styles,
    '&:hover': {
      backgroundColor: '#eee'
    },
    cursor: 'pointer',
    textAlign: 'left',
    color: '#4973b4',
    backgroundColor: state.isSelected ? '#fff' : '',
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: "'proxima-nova'"
  }),
  indicatorSeparator: styles => ({ ...styles, width: '0px' }),
  valueContainer: styles => ({
    ...styles,
    padding: '0px 8px',
    color: '#4973b4',
    fontSize: '14px',
    fontWeight: 500,
    textAlign: 'left',
    fontFamily: "'proxima-nova'"
  }),
  dropdownIndicator: styles => ({
    ...styles,
    padding: '2px 4px',
    color: '#4973b4',
    fontFamily: "'proxima-nova'"
  }),
  singleValue: styles => ({
    ...styles,
    color: '#4973b4',
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: "'proxima-nova'"
  })
}

export const customSelectStyles = {
  control: styles => ({
    ...styles,
    backgroundColor: 'white',
    minHeight: '28px',
    cursor: 'pointer',
    padding: '4px 0px',
    borderRadius: '5px',
    width: '140px'
  }),
  menu: styles => ({
    ...styles,
    width: 'max-content',
    minWidth: '100%'
  }),
  placeholder: styles => ({
    ...styles,
    fontSize: '14px',
    textAlign: 'left'
  }),
  input: styles => ({
    ...styles,
    fontSize: '14px',
    textAlign: 'left'
  }),
  option: styles => ({
    ...styles,
    cursor: 'pointer',
    textAlign: 'left',
    fontSize: '14px',
    fontWeight: 500,
    padding: '10px 15px'
  }),
  indicatorSeparator: styles => ({ ...styles, width: '0px' }),
  valueContainer: styles => ({
    ...styles,
    padding: '0px 8px',
    fontSize: '14px',
    fontWeight: 500,
    textAlign: 'left'
  }),
  dropdownIndicator: styles => ({
    ...styles,
    padding: '2px 4px',
  }),
  singleValue: styles => ({
    ...styles,
    fontSize: '14px',
    fontWeight: 500
  })
}